// extracted by mini-css-extract-plugin
export default {"root":"PageContainer_root-EKx","button":"PageContainer_button-U9b","wrapper":"PageContainer_wrapper-UNr","title":"PageContainer_title-UDf"};